import { useAuthStore } from "@/stores/auth";
import { useCountryStore } from "@/stores/country";

import {
  identifyUser as posthogIdentify,
  getPosthogPerson,
} from "@/plugins/posthog.js";

import {
  getNativeAnalyticsPerson,
  oneSignalIdentify,
  firebaseIdentify,
  metaIdentify,
  tikTokIdentify,
} from "@/utils/tracking";

export function useIdentifyUser() {
  const authStore = useAuthStore();
  const countryStore = useCountryStore();

  function identifyUser(user) {
    try {
      const posthogUserProperties = getPosthogPerson(user);
      posthogIdentify(user.id, posthogUserProperties, {
        startRecording: true,
        registerCompleted: authStore.isRegisterCompleted(),
      });

      if (window.SababuuNativeBridge) {
        const nativeAnalyticsUserProperties = getNativeAnalyticsPerson(user);

        firebaseIdentify(user.id, nativeAnalyticsUserProperties, {
          registerCompleted: authStore.isRegisterCompleted(),
        });

        // We only identify OneSignal & Meta if we have gender on the user
        // which means the user has completed the UserDetails onboarding step.
        // For OneSignal, this identify call will initialize it.
        if (user.gender) {
          oneSignalIdentify(user.id, nativeAnalyticsUserProperties, {
            registerCompleted: authStore.isRegisterCompleted(),
          });

          metaIdentify(user.id, {
            phone: user.phone.replace(/\+/g, ""),
            dateOfBirth: user.birthday.replace(/-/g, ""),
            ...(countryStore.countryData?.alphaTwoCode && {
              country: countryStore.countryData?.alphaTwoCode,
            }),
            gender: user.gender === "female" ? "f" : "m",
          });

          tikTokIdentify(user.id, {
            phone: user.phone.replace(/\+/g, ""),
          });
        }
      }
    } catch (ex) {
      console.error("Failed to identify with ex: ", ex);
    }
  }

  return {
    identifyUser,
  };
}
